import React from 'react';
import Loading from '../loading';

const LoadingMap = () => (
  <Loading size={20} variant="h6" message="Cargando map 🗺" />
);

export default LoadingMap;
